import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree,} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {StorageService} from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AnonymousGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private storage: StorageService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.auth.alreadyLoggedIn()) {
      return true;
    } else {
      return this.routeChecker()
    }
  }

  routeChecker() {
    const profile = this.storage.getItem('profile');
    if ((profile?.profileType === 'INST' || profile?.profileType === 'POPSM')) {
      return this.router.navigate(['', 'tgsd-landing']);

    } else if (profile?.profileType === 'CIT') {
      this.router.navigate(['', 'tgsd-client']);
    }
  }


}
